/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Review_Category_SpellingInputs */

const en_cv_review_category_spelling = /** @type {(inputs: Cv_Review_Category_SpellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelling & Grammar`)
};

const de_cv_review_category_spelling = /** @type {(inputs: Cv_Review_Category_SpellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtschreibung & Grammatik`)
};

/**
* | output |
* | --- |
* | "Spelling & Grammar" |
*
* @param {Cv_Review_Category_SpellingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_review_category_spelling = /** @type {((inputs?: Cv_Review_Category_SpellingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Review_Category_SpellingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_review_category_spelling(inputs)
	return en_cv_review_category_spelling(inputs)
});